@if (generalAppData.logoDownloaded && !forHomePage) {
  <h1 class="m-0 p-0 ms-1">
    <!-- style="min-width: 250px" -->
    <a class="text-primary d-flex justify-content-center" routerLink="/">
      <img [src]="imagesrc" [alt]="env.name" />
    </a>
  </h1>
}
@if (generalAppData.logoDownloaded && forHomePage) {
  <img
    class="d-none d-md-block"
    [src]="imagesrc"
    [alt]="env.name"
    />
}
@if (generalAppData.logoDownloaded && forHomePage) {
  <img
    class="d-block d-md-none"
    [src]="mobileImagesrc ? mobileImagesrc : imagesrc"
    [alt]="env.name"
    />
}
